/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { SlabNavContainer, SlabNavItem } from '.';

const metrics = [
    { key: 'exposures', label: 'Exposures', icon: 'paper-plane fal' },
    { key: 'impressions', label: 'Impressions', icon: 'eye fal' },
    { key: 'engagements', label: 'Engagements', icon: 'thumbs-up fal' },
    { key: 'mediaValue', label: 'Media Value', icon: 'dollar-sign fal' },
];

export const DefaultSlabNavExample = () => (
    <SlabNavContainer vertical justify>
        <SlabNavItem icon="paper-plane fal" label="Exposures" size="xs" vertical justify />
        <SlabNavItem icon="eye fal" label="Impressions" size="xs" vertical justify />
        <SlabNavItem icon="thumbs-up fal" label="Engagements" size="xs" vertical justify />
    </SlabNavContainer>
);

export const ActiveSlabNavExample = () => {
    const [selected, setSelected] = React.useState('impressions');

    return (
        <SlabNavContainer vertical justify>
            {metrics.map(({ key, label, icon }) => (
                <SlabNavItem
                    key={key}
                    icon={icon}
                    label={label}
                    size="xs"
                    vertical
                    justify
                    selected={selected === key}
                    onClick={() => setSelected(key)}
                />
            ))}
        </SlabNavContainer>
    );
};

export const DisabledSlabNavExample = () => (
    <SlabNavContainer vertical justify>
        <SlabNavItem
            icon="thumbs-up fal"
            label="Engagements"
            size="xs"
            vertical
            justify
            selected
        />
        <SlabNavItem
            icon="lock fal"
            label="Sponsor Value"
            size="xs"
            vertical
            justify
            disabled
        />
    </SlabNavContainer>
);

export const ManyItemsSlabNavExample = () => {
    const [selected, setSelected] = React.useState('item-0');
    const items = Array.from({ length: 8 }, (_, index) => ({
        key: `item-${index}`,
        label: `Metric ${index + 1}`,
        icon: 'chart-line fal',
    }));

    return (
        <SlabNavContainer vertical justify>
            {items.map(({ key, label, icon }) => (
                <SlabNavItem
                    key={key}
                    icon={icon}
                    label={label}
                    size="xs"
                    vertical
                    justify
                    selected={selected === key}
                    onClick={() => setSelected(key)}
                />
            ))}
        </SlabNavContainer>
    );
};

// Opt-in light/brand tone: the clean AntD-tokened look instead of the default
// legacy dark slab.
export const BrandToneSlabNavExample = () => {
    const [selected, setSelected] = React.useState('impressions');

    return (
        <SlabNavContainer vertical justify tone="brand">
            {metrics.map(({ key, label, icon }) => (
                <SlabNavItem
                    key={key}
                    icon={icon}
                    label={label}
                    size="xs"
                    vertical
                    justify
                    selected={selected === key}
                    onClick={() => setSelected(key)}
                />
            ))}
        </SlabNavContainer>
    );
};
